export default {
  gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID,
};
